module.exports = __webpack_public_path__ + "img/chips200000.8dc0cf4d.png";